import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { ApiService } from './api.service';

type SocketFactory = (url: string, options: any) => Socket;
export const SOCKET_IO_FACTORY = new InjectionToken<SocketFactory>('SOCKET_IO_FACTORY');

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;
  static socketId: string | undefined;

  constructor(
    private apiService: ApiService,
    @Optional() @Inject(SOCKET_IO_FACTORY) private socketFactory?: SocketFactory
  ) {
    const createSocket = this.socketFactory ?? io;
    this.socket = createSocket(this.apiService.url, {
      withCredentials: true,
      secure: true,
      transports: ['websocket', 'polling']
    });
    this.socket.on('connect', () => {
        console.log('Socket connected with ID:', this.socket.id);
        // this.SocketService.socketId = this.socket.id;
        SocketService.socketId = this.socket.id;
    });
  }

  socketConnection(callback: (data: any) => void): void {
    this.socket.on('socket_connection', callback)
  }

  emitRequestOtp(email: string): void {
    this.socket.emit('request_otp', { email });
  }

  onOtpStatus(callback: (data: { email: string; status: string }) => void): void {
    this.socket.on('otp_status', callback);
  }

  disconnect(): void {
    this.socket.disconnect();
  }
}
